module.exports = __webpack_public_path__ + "img/supplyBrain.aba1f78c.png";